import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROLES } from '../../constants';
import { useDepartmentsQuery } from './useDepartmentsQuery';

export const useDepartmentManagement = () => {
  const navigate = useNavigate();

  const organisationId = useMemo(() => localStorage.getItem('organisationId') || undefined, []);

  const userRole = useMemo(() => localStorage.getItem('userRole'), []);

  const { data: departments = [], isLoading, error, refetch } = useDepartmentsQuery(organisationId);

  useEffect(() => {
    if (userRole !== ROLES.PRACTISE_ADMIN && userRole !== ROLES.SUPER_ADMIN) {
      navigate('/dashboard');
    }
  }, [userRole, navigate]);

  return {
    departments,
    isLoading,
    error: error instanceof Error ? error.message : null,
    fetchDepartments: refetch
  };
};
